export default {
  ticker: 'Mã',
  issuerTicker: 'TCPH',
  derivativeTypeName: 'Loại CQ',
  conversionRate: 'Tỷ lệ CĐ',
  issuePrice: 'Giá PH',
  referencePrice: 'Giá TC',
  matchPrice: 'Giá',
  priceChange: '+/-',
  percentPriceChange: '% +/-',
  totalMatchVolume: 'Tổng KL',
  totalMatchValue: 'Tổng GT  ',
  best1Bid: 'Giá mua 1',
  best1Offer: 'Giá bán 1',
  dayRange: 'Biến động ngày',
  ceilingPrice: 'Trần ',
  floorPrice: 'Sàn',
  openPrice: 'Mở cửa',
  highestPrice: 'Cao nhất',
  lowestPrice: 'Thấp nhất',
  basis: 'Độ lệch',
  performance: 'Diễn biến giá',
  foreignBuyVolumeTotal: 'KLNN Mua',
  foreignSellVolumeTotal: 'KLNN Bán',
  FR_BUY_VAL: 'GTNN Mua',
  FR_SELL_VAL: 'GTNN Bán',
  dealPrice: 'Giá thỏa thuận',
  totalDealVolume: 'Tổng KL thỏa thuận',
  totalDealValue: 'Tổng GT thỏa thuận',
  SYMBOL_TICKER: 'TSCS',
  exercisePrice: 'Giá thực hiện',
  averagePrice1Week: 'Giá TB 5D',
  BREAK_EVEN_PRICE: 'Giá hòa vốn',
  orgMatchPrice: 'Giá hiện tại',
  PREMIUM: '%Lãi/Lỗ',
  maturityDate: 'Ngày đáo hạn',
  lastTradingDate: 'Ngày GDCC',
};
